import { useChatStore } from '../store/chat-store';
import { Avatar } from './Avatar';

const LABELS: Record<string, { text: string; dot: string; ring?: string }> = {
  idle:         { text: 'Idle',           dot: 'bg-gray-400' },
  connecting:   { text: 'Connecting…',     dot: 'bg-amber-400 animate-pulse' },
  connected:    { text: 'Online',          dot: 'bg-emerald-500 dot-online' },
  reconnecting: { text: 'Reconnecting…',   dot: 'bg-amber-400 animate-pulse' },
  error:        { text: 'Disconnected',    dot: 'bg-red-500' },
};

export function Header({ onLeave }: { onLeave?: () => void }) {
  const online = useChatStore(s => s.online);
  const conn = useChatStore(s => s.connState);
  const identity = useChatStore(s => s.identity);
  const err = useChatStore(s => s.errorMessage);
  const label = LABELS[conn] ?? LABELS.idle;

  return (
    <div className="vip-header-bg text-white px-3.5 py-3">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2.5 min-w-0">
          {identity ? (
            <div className="shrink-0 ring-2 ring-white/30 rounded-full">
              <Avatar userId={identity.userId} name={identity.name} size={34} />
            </div>
          ) : (
            <div className="w-8 h-8 rounded-lg bg-white/15 flex items-center justify-center shrink-0">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
              </svg>
            </div>
          )}
          <div className="leading-tight min-w-0">
            <div className="text-sm font-semibold truncate">
              {identity?.name ?? 'VIP Chat'}
            </div>
            <div className="flex items-center gap-1.5 text-[11px] text-white/85">
              <span className={`inline-block h-1.5 w-1.5 rounded-full ${label.dot}`} />
              <span title={err ?? ''}>{label.text}</span>
              {online > 0 && conn === 'connected' && (
                <span className="text-white/65">· {online} online</span>
              )}
            </div>
          </div>
        </div>

        {onLeave && (
          <button
            type="button"
            onClick={onLeave}
            title="Leave chat"
            aria-label="Leave chat"
            className="shrink-0 rounded-full bg-white/15 hover:bg-white/25 transition w-8 h-8 flex items-center justify-center"
          >
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
